import React from "react";

type FoundryBadgeVariant =
  | "default"
  | "orange"
  | "green"
  | "red"
  | "blue"
  | "purple"
  | "slate";

type FoundryBadgeProps = {
  children: React.ReactNode;
  variant?: FoundryBadgeVariant;
  className?: string;
};

const variantClasses: Record<FoundryBadgeVariant, string> = {
  default:
    "bg-slate-100 text-slate-600 dark:bg-white/10 dark:text-slate-300",
  orange:
    "bg-orange-100 text-orange-700 dark:bg-orange-500/10 dark:text-orange-300",
  green:
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300",
  red:
    "bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-300",
  blue:
    "bg-blue-100 text-blue-700 dark:bg-blue-500/10 dark:text-blue-300",
  purple:
    "bg-purple-100 text-purple-700 dark:bg-purple-500/10 dark:text-purple-300",
  slate:
    "bg-slate-100 text-slate-600 dark:bg-white/10 dark:text-slate-300",
};

const FoundryBadge: React.FC<FoundryBadgeProps> = ({
  children,
  variant = "default",
  className = "",
}) => {
  return (
    <span
      className={[
        "rounded-full px-2 py-1 text-xs font-bold",
        variantClasses[variant],
        className,
      ].join(" ")}
    >
      {children}
    </span>
  );
};

export default FoundryBadge;
